// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__woE15","col":"styles_col__2Qi8N"};